/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetPlanShortResponseDto
 */
export interface AssetPlanShortResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssetPlanShortResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetPlanShortResponseDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof AssetPlanShortResponseDto
     */
    name: string;
}

/**
 * Check if a given object implements the AssetPlanShortResponseDto interface.
 */
export function instanceOfAssetPlanShortResponseDto(value: object): value is AssetPlanShortResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function AssetPlanShortResponseDtoFromJSON(json: any): AssetPlanShortResponseDto {
    return AssetPlanShortResponseDtoFromJSONTyped(json, false);
}

export function AssetPlanShortResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetPlanShortResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'name': json['name'],
    };
}

export function AssetPlanShortResponseDtoToJSON(json: any): AssetPlanShortResponseDto {
    return AssetPlanShortResponseDtoToJSONTyped(json, false);
}

export function AssetPlanShortResponseDtoToJSONTyped(value?: AssetPlanShortResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'name': value['name'],
    };
}

